module.exports = __webpack_public_path__ + "static/media/user_selected.b0a9bdd9.svg";